enum CustomFilterByType {
    TEXT_TYPE = 1,
    NUMBER_TYPE,
    DATE_TYPE,
    TOGGLE_TYPE
}

export class FilterItem {
    constructor(public value:any, public label:string) {
    }
}

export class FilterItemTyped extends FilterItem {
    constructor(public type:CustomFilterByType, public value:any, public label:string, public statusOn:string, public statusOff:string, public inputValue:any) {
        super(value, label);
    }
}

export {CustomFilterByType}